"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineFeedback = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _statusIconAppearance = require("../../util/statusIconAppearance");
var _InlineFeedback = require("./InlineFeedback.styles");
var _excluded = ["icon", "children"];
/**
 * `InlineFeedback` is a subtle status message that is embedded within the content of the page.
 * For a more prominent message, consider using the `Alert` component.
 *
 * @since 7.17.0
 */
var InlineFeedback = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var icon = props.icon,
    children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var iconContent = icon;
  if (typeof icon === 'function') {
    iconContent = icon(props);
  }
  return /*#__PURE__*/_react.default.createElement(_InlineFeedback.StyledInlineFeedback, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), iconContent, children);
});
exports.InlineFeedback = InlineFeedback;
InlineFeedback.displayName = 'InlineFeedback';
InlineFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type and style of inline feedback to display.
   */
  appearance: _propTypes.default.oneOf([].concat((0, _toConsumableArray2.default)(Object.keys(_constants.STATUS_TYPES)), ['transient'])),
  /**
   * The icon node. By default, this will use an icon based on the inline feedback `appearance`.
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The text content of the inline feedback message.
   */
  children: _propTypes.default.node.isRequired
} : {};
InlineFeedback.defaultProps = {
  appearance: 'info',
  icon: _statusIconAppearance.statusIconAppearance
};